import { ApiError } from '../net/client';

/**
 * What sign-in says, D20. The copy is the mobile app's `WelcomeScreen.tsx`
 * except `notATenant`, which the user's ruling asked for and no source draws.
 */

/** A sentence, and an optional second one in muted ink, as mobile's `InlineRefusal`. */
export interface Refusal {
  message: string;
  hint?: string;
}

/** The words for `not_a_tenant`. Invented, and recorded as such in D20. */
export const notATenant: Refusal = {
  message: 'This account does not belong to a brand.',
  hint: "Ask your brand's admin for an invitation.",
};

/**
 * A refusal that belongs to no field. The copy is mobile's `bannerFor`: a rate
 * limit, no answer at all, and one message for everything else, since a user
 * can do the same thing about each of them.
 */
export function bannerFor(error: unknown): Refusal {
  if (error instanceof ApiError && error.code === 'not_a_tenant') return notATenant;
  if (error instanceof ApiError && error.kind === 'rate_limited') {
    return { message: 'Too many attempts from this device.', hint: 'Wait a minute and try again.' };
  }
  if (error instanceof ApiError && error.kind === 'network') {
    return { message: 'No connection.', hint: 'Check your signal and try again.' };
  }
  return { message: 'Something went wrong at our end.', hint: 'Try again in a moment.' };
}
